import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27d1dae1"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "name-container",
    id: "renderingNameContainer",
    ref: "containerRef",
    style: _normalizeStyle({ height: _ctx.height + 'px' })
  }, [
    (_ctx.height > 0)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "name-font",
          style: _normalizeStyle({ color: _ctx.fontColor, fontSize: _ctx.fontSize }),
          innerHTML: _ctx.fontChar
        }, null, 12, _hoisted_1))
      : _createCommentVNode("", true)
  ], 4))
}